export default "__VITE_ASSET__0f25cc56__"